import React from 'react';
import { Link } from 'react-router-dom';
import { UserShape } from '../shapes';
import PropTypes from 'prop-types';
import Person from '../components/person';

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  static propTypes = {
    user: UserShape,
    onStartLoginProcess: PropTypes.func,
    onReset: PropTypes.func
  }

  state = {
    loginProcessTriggered: false,
    email: undefined
  }

  componentDidMount() {
    this.props.onReset();
    document.addEventListener("keydown", this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyDown);
  }

  render() {
    if (this.props.user.get('error')) {
      return this.renderLoginError();
    } else if (this.state.loginProcessTriggered) {
      return this.renderLoginProcessTriggered();
    } else {
      return this.renderPerson();
    }
  }

  renderLoginProcessTriggered() {
    return (
      <div className='row confirmation'>
        <div className='col-sm-12'>
          { `Right on. We've sent you an email with a magic link to login. Check your inbox!`}
        </div>
        <div className='col-sm-12 action center'>
          <Link to='/' className='btn btn-dark' data-primary-cta='true'>Got It</Link>
        </div>
      </div>
    );
  }

  renderPerson() {
    return(
      <div>
        <div className='row email-explainer-section'>
          <div className='col-sm-12'>
            <h1>Login</h1>
            Enter your Yak Tack email address, and we’ll send a magic link to your inbox so you can log in.
          </div>
        </div>
        <Person email={ this.state.email } onEmailChange={ this.onEmailChange.bind(this) }></Person>
        <div className='clearfix'></div>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='action'>
              <Link to='/' className='btn btn-outline-secondary'>Nevermind</Link>
              <button data-behavior='login' onClick={ this.onStartLoginProcess.bind(this) } className='btn btn-dark' type='button' data-primary-cta='true'>Login</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLoginError() {
    return(
      <div className='error' >
        <div className='col-sm-12'>
          { `Hmm. ${ this.props.user.get('error') }.` }
        </div>
        <div className='col-sm-12 action center'>
          <Link to='#' onClick={ e => this.onTryAgain(e) } className='btn btn-dark' data-primary-cta='true'>Ah, Ok</Link>
        </div>
      </div>
    );
  }

  onTryAgain(e) {
    e.preventDefault();
    this.setState({ loginProcessTriggered: false }, this.props.onReset);
  }

  onEmailChange(event) {
    this.setState({
      email: event.target.value
    });
  }

  onStartLoginProcess() {
    this.props.onStartLoginProcess(this.state.email);
    this.setState({ loginProcessTriggered: true });
  }

  onKeyDown(e) {
    switch (e.key) {
      case "Enter": {
        e.preventDefault();
        this.onStartLoginProcess();
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/login.jsx